import PropTypes from 'prop-types'
import React from 'react'

export const AddressVerification = ({isVerified, needShowText}) =>
  <div className={
    `sidebar-user-verifikacija-item user-card__verification-address ${isVerified ? 'is-verifikovana' : ''}`
  }>
    <i className='ico-user-verifikacija-lokacije ico' />
    {needShowText ? <p>verifikovana lokacija</p> : null}
  </div>

AddressVerification.propTypes = {
  isVerified: PropTypes.bool.isRequired,
  needShowText: PropTypes.bool.isRequired
}

AddressVerification.defaultProps = {
  isVerified: false,
  needShowText: true
}
